"use strict";

require("core-js/modules/es6.string.small");

var _taggedTemplateLiteral = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    cursor: not-allowed;\n\n    &:hover,\n    &:focus,\n    &:visited,\n    &:link {\n      border: none;\n      color: ", ";\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  text-decoration: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  display: inline-flex;\n  align-items: center;\n  text-align: left;\n  cursor: pointer;\n  padding: 16px 32px 16px 16px;\n\n  &:hover {\n    color: ", ";\n  }\n\n  &:focus {\n    outline: none;\n    ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionLinkDisabled = exports.actionLinkUnderline = exports.actionLinkCustomColor = exports.actionLinkBase = void 0;

var _stylitas = require("@creditas/stylitas");

var actionLinkBase = function actionLinkBase(_ref) {
  var theme = _ref.theme;
  return (0, _stylitas.css)(_templateObject(), _stylitas.utilities.typography.action(theme), _stylitas.utilities.radius.small(), theme.bColorsecondary06, _stylitas.utilities.border.thin({
    theme: theme,
    color: theme.bColorsecondary04
  }));
};

exports.actionLinkBase = actionLinkBase;

var actionLinkCustomColor = function actionLinkCustomColor(_ref2) {
  var theme = _ref2.theme,
      color = _ref2.color;
  return (0, _stylitas.css)(_templateObject2(), color ? color : theme.bColorsecondary04);
};

exports.actionLinkCustomColor = actionLinkCustomColor;

var actionLinkUnderline = function actionLinkUnderline(_ref3) {
  var underline = _ref3.underline;
  return (0, _stylitas.css)(_templateObject3(), underline);
};

exports.actionLinkUnderline = actionLinkUnderline;

var actionLinkDisabled = function actionLinkDisabled(_ref4) {
  var theme = _ref4.theme,
      disabled = _ref4.disabled;
  return disabled && (0, _stylitas.css)(_templateObject4(), theme.bColorneutral04, theme.bColorneutral04);
};

exports.actionLinkDisabled = actionLinkDisabled;